import React from "react";
import { Link } from "react-router-dom";

/**
 * Etusivun yleinen teaser-osio.
 *
 * Props:
 *  - title?: string                 (otsikko, all caps; voi olla tyhjä)
 *  - body: string                   (lyhyt esittelyteksti)
 *  - linkLabel: string              ("Lue lisää", "Tutustu", jne.)
 *  - linkTo: string                 (sisäinen reitti tai ulkoinen URL)
 *  - external?: boolean             (jos true → <a target="_blank">)
 */
const SectionTeaser = ({
  title,
  body,
  linkLabel,
  linkTo,
  external = false,
}) => {
  return (
    <section className="teaser">
      <div className="teaser__inner">
        {title && <h2 className="teaser__title">{title}</h2>}
        <p className="teaser__body">{body}</p>
        {linkTo &&
          (external ? (
            <a
              href={linkTo}
              target="_blank"
              rel="noopener noreferrer"
              className="teaser__link"
            >
              {linkLabel} →
            </a>
          ) : (
            <Link to={linkTo} className="teaser__link">
              {linkLabel} →
            </Link>
          ))}
      </div>
    </section>
  );
};

export default SectionTeaser;
